import {FC} from 'react'
import {InputInterface} from './types'

const CheckBox: FC<InputInterface> = ({formik, name, label}) => {

  const fieldProps = formik.getFieldProps(name)

  return (
    <div className="form-check form-switch form-check-custom form-check-solid">
      <input type="checkbox"
             className="form-check-input h-20px w-30px"
             {...fieldProps}
             checked={fieldProps.value}
             id={name}
      />
      <label className={`form-check-label text-hover-gray-600 fs-7 fs-sm-5 p-2 ${fieldProps.value ? 'text-primary' : 'text-muted'}`}
             htmlFor={name}>
        {label}
      </label>
    </div>
  )
}

export {CheckBox}